<!-- 机构-课程管理 -->
<template>
  <div class="container">
    <div class="index" v-if="!detail.show && !add.show ">
      <div class="title">
        <span>{{ $route.name }}</span>
      </div>
      <div class="query">
        <el-form ref="form" :model="form" label-width="90px"> </el-form>
        <div class="query">
          <el-form ref="form" :inline="true" :model="form" label-width="90px">
            <el-form-item label="">
              <coure-type @setCourseType="setCourseType" type="seach"></coure-type>
              <!-- <el-select
                v-model="form.typeId"
                placeholder="请选择课程类型"
                clearable
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="">
              <el-select
                v-model="form.auditState"
                placeholder="请选择审核状态"
                clearable
              >
                <el-option
                  v-for="item in auditStateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="">
              <el-select
                v-model="form.state"
                placeholder="请选择课程状态"
                clearable
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="">
              <el-input
                v-model="form.cname"
                clearable
                placeholder="请输入课程名称"
              />
            </el-form-item>
            <el-form-item label="" style="float: right">
              <el-button type="primary" size="small" @click="searchFun"
                >搜索</el-button
              >
              <el-button size="small" @click="toAdd">创建课程</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column
            align="center"
            label="课程封面"
          >
            <template slot-scope="scope">
              <img :src="scope.row.coverUrl" style="height: 42px" alt="" />
            </template>
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="cname" label="课程名称">
          </el-table-column>
          <el-table-column
            align="center"
            label="课程类型"
            
          >
            <template slot-scope="scope">
              {{ scope.row.typeName ||''}} {{scope.row.subclassName?"/ "+scope.row.subclassName :''}}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="coverArea"
            label="覆盖区域"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="auditState"
            label="审核状态"
             width="80"
          >
            <template slot-scope="scope">
              {{ scope.row.auditState | auditStateFilter }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="250"
            label="操作"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="toDetail(scope.row)">查看详情</el-button>
              <!-- 只有未审核和审核不通过才能送审 -->
							<template v-if="scope.row.auditState=='0' || scope.row.auditState=='3'">
							<el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
							<el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
							<el-button type="text" size="small" @click="handle(scope.row, '确定送审吗?')">送审</el-button>
							</template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
    <Detail :info.sync="detail.info" v-show="detail.show" @to-index="toIndex"></Detail>
    <Add :info.sync="add.info" v-show="add.show" @to-index="toIndex" @to-init="init" ></Add>
  </div>
</template>
<script>
import educationApi from '@/api/education/index.js'
import {
  handleInstitutionList,
  submitaudit,
  handleStandupanddown,
  handleDelete,
  getDetail
} from "@/api/mechanismApi/curriculum";
import util from '@/utils/util.js'
import _ from "lodash";
import dayjs from "dayjs";
export default {
  components: {
    Detail: () => import("./curriculumDetail.vue"),
    Add: () => import("./addCurriculum.vue"),
    coureType: () => import("@/views/components/coureType.vue"),
  },
  data() {
    return {
      form: {
        typeId: "",
        subclassId:"",
        auditState: "",
        state: "",
        cname: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 10,
      },
      tableData: [],
      typeList: [
        { id: "1", label: "素养课程",value: "1"  },
        { id: "2", label: "社团活动" ,value: "2"  },
      ],
      auditStateList: [
        { id: "0", label: "未审核 ", value: "0" },
        { id: "1", label: "待审核 ", value: "1" },
        { id: "2", label: "审核通过 ", value: "2" },
        { id: "3", label: "审核不通过 ", value: "3" },
        { id: "4", label: "已下架   ", value: "4" },
      ],
      stateList: [
        { id: "0", label: "未上架", value: "0" },
        { id: "1", label: "已上架", value: "1" },
      ],
      currentPage: 4,
      detail: {
        info: {},
        show: false,
      },
      add:{
				info:{},
        show:false,
        
			},
    };
  },
  filters: {
    typeFilter(type) {
      const typeMap = {
         1: "素养课程",
         2: "社团活动",
      };
      return typeMap[type];
    },
    stateFilter(type) {
      const typeMap = {
        0: "未上架",
        1: "已上架",
      };
      return typeMap[type];
    },
    auditStateFilter(type) {
      const typeMap = {
        0: "未审核",
        1: "待审核",
        2: "审核通过",
        3: "审核不通过",
        4: "下架  ",
      };
      return typeMap[type];
    },
  },
  mounted() {
    // this.$router.push('/supervise/curriculum')
  },
  created() {
    this.getDataList();
  },
  methods: {
    async getDataList() {
      let params = {
        typeId: this.form.typeId, //大的课程类型
        subclassId: this.form.subclassId,//小的课程类型
        auditState: this.form.auditState, //审核状态
        state: this.form.state,
        cname: this.form.cname,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      var { data, result } = await handleInstitutionList(params);
      // console.log("获取课程列表---第一次测试", data);
      if (result == "000000") {
        this.tableData = data.list;
        this.page.totalPage = data.total;
      }
      let params1 = {
        org_id:sessionStorage.getItem("orgId"), //课程类型
        get_more:'1', //审核状态
      };
    },

    toAdd() {
      this.add.info={};
			this.add.show=true;
    },
    init(){
      this.add.show=false;
      this.form =  {
        typeId: "",
        auditState: "",
        state: "",
        cname: "",
      },
			this.page.pageNum=1;
			this.getDataList();
		},
    async toDetail(item){
			let params = {
				id: item.cid,
			};
     let paramsData= {
			cid: item.cid,
			orgId:sessionStorage.getItem("orgId"),
			};
			var { result,data } = await getDetail(params);
      let res= await educationApi.getEducationCourseauditrecord(paramsData);
			if (result == "000000") {
				this.detail.info = data;
        if(res.result==='000000'){
					if (res.data.length != 0) {
						this.detail.info.operateList=res.data || [];
					}else{
						this.detail.info.operateList=[{
							auditState: "",
							operateOpinion: "无审核记录",
							operateOrgName: "",
						}]
					}
				}
				this.detail.show = true;
			} else {
				this.$message({
				type: "error",
				message: "获取信息失败",
				});
			}
    },
    async edit(item){
			let params = {
				id: item.cid,
			};
			var { result,data } = await getDetail(params);
			if (result == "000000") {
				this.add.info = data;
				this.add.show = true;
			} else {
				this.$message({
				type: "error",
				message: "获取信息失败",
				});
			}
		},
		// 送审
     handle: _.throttle(
      function (item) {
        this.handleSubmitaudit(item);
      },
      3000,
      { leading: true, trailing: false }
    ),
		async handleSubmitaudit(item, text, type){
			let vm=this;
			util.handleCofirm(text, 'info',).then(async res => {
				let params = {
					cid: item.cid,
          proviceCode: item.proviceCode,
          cityCode: item.cityCode,
          areaCode: item.areaCode,
				};
				var { result } = await submitaudit(params);
				if (result == "000000") {
					vm.$message({
						type: "success",
						message: "操作成功",
					});
					vm.getDataList();
				} else {
					vm.$message({
						type: "error",
						message: "操作失败",
					});
				}
			}).catch(err => {
				console.log('err', err) // cancel
			})
		},
		async del(item){
			let vm=this;
			util.handleCofirm('确定要删除课程吗?', 'info',).then(async res => {
				let params = {
					cid: item.cid,
          proviceCode: item.proviceCode,
          cityCode: item.cityCode,
          areaCode: item.areaCode,
				};
				var { result } = await handleDelete(params);
				if (result == "000000") {
					vm.$message({
						type: "success",
						message: "操作成功",
					});
					vm.getDataList();
				} else {
					vm.$message({
						type: "error",
						message: "操作失败",
					});
				}
			}).catch(err => {
				console.log('err', err) // cancel
			})
		},
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.getDataList();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.getDataList();
    },

    toIndex() {
      this.detail.show=false;
			this.add.show=false;
      this.getDataList();
    },
     setCourseType(data){ 
      this.form.typeId=data.typeId || ''
      this.form.subclassId=data.subclassId || ''
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  /* width: 170px; */
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container{
  width: 100%;
  height: 100%;
}
.index{
  width: 100%;
  height: 100%;
  padding: 0px 30px 30px;
  overflow: auto;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin-top: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}
</style>
